import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

import { ProductionProgressBar } from "./ProductionProgressBar"

const useStyles = makeStyles()((theme) => ({
    label: {
        fontWeight: 600,
        whiteSpace: "nowrap",
        color: theme.palette.tailwind.slate[500],
    },
}))

type Props = Readonly<{
    ready: number
    total: number
}>

export function ProductionReadyProgress({ ready, total }: Props) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" alignItems="center" spacing=".75rem">
            <ProductionProgressBar ready={ready} total={total} />
            <LocalizedStrict id="meeting-service-production-view-ready-count" vars={{ ready, total }}>
                <Typography component="span" className={classes.label}>
                    {ready}/{total} ready
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
